import { render, staticRenderFns } from "./ClientsInvoiceCodeList.vue?vue&type=template&id=05b1f5b4&"
import script from "./ClientsInvoiceCodeList.vue?vue&type=script&lang=js&"
export * from "./ClientsInvoiceCodeList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsInvoiceCodeList.vue?vue&type=style&index=0&id=05b1f5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports